<template>
    <el-header>
        <div class="h-100 header-left">
            <el-avatar class="app-bar-icon" @click.stop="toggleMenu">
                <el-icon><Expand /></el-icon>
            </el-avatar>
            <router-link to="/" class="text-decoration-none app-link">
                eP2AS Licenses
            </router-link>
        </div>
        <div class="h-100 header-right">
            <el-dropdown v-if="user != null">
                <span class="el-dropdown-link">
                    <el-avatar>
                        <el-icon><UserFilled /></el-icon>
                    </el-avatar>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item>
                            Email: {{ user.username }}
                        </el-dropdown-item>
                        <el-dropdown-item @click="logout">
                            logout
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
    </el-header>
</template>

<script lang="ts">
import { useStore } from 'vuex';
import { UserFilled, Expand } from '@element-plus/icons';
import { defineComponent, computed, ref } from 'vue';
import { CognitoUser } from '@/types/CognitoUser';

export default defineComponent({
    components: { UserFilled, Expand },
    props: {},
    emits: ['toggle-menu'],
    setup(props, context) {
        const store = useStore();
        const user = computed((): CognitoUser => {
            return store.state.auth.user;
        });
        const logout = () => {
            store.dispatch('auth/logout');
        };

        const toggleMenu = () => {
            context.emit('toggle-menu');
        };

        return {
            user,
            toggleMenu,
            logout,
            UserFilled,
            Expand,
        };
    },
});
</script>
<style>
.app-link {
    font-size: 1.25rem;
    font-weight: 700;
    color: #eee !important;
}

.header-left {
    float: left;
    display: flex;
    align-items: center;
}

.header-right {
    float: right;
    display: flex;
    align-items: center;
}
</style>
